<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.txt-color {
  word-break: keep-all;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
  margin: 0 4px;
}

.row-import {
  display: flex;
  margin-bottom: 20px;
  margin-left: 18px;
}

.row-import .left {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  padding-top: 4px;
}

.row-import .right {
  font-size: 14px;
}

.tipInfo {
  margin-top: 10px;
  color: #646464;
  line-height: 30px;
}

.el-col-8 {
  display: flex;
  /* margin-bottom: 15px; */
}

.ipt-sty {
  flex: 1;
}

.reject-btn.btn {
  background: #FFF2F4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #FB2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;

}

.pass-btn.btn {
  background: #F2FFF5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1BA854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #FF991C;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #F5F5F5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">委托方&nbsp;&nbsp;&nbsp;</div>
          <el-select @change="handleChangeCompany" v-model="page.tenantGuid" placeholder="请选择委托方" class="ipt-sty"
            filterable size="mini">
            <el-option v-for="(item, index) in sendTenantList" :key="index" :label="item.sendTenantName"
              :value="item.sendTenantGuid"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">执行部门</div>
          <el-select v-model="page.organisationInfo" filterable placeholder="请选择执行部门" class="ipt-sty" size="mini">
            <el-option v-for="(item, index) in organisationList" :key="index" :label="item.organisationName"
              :value="item.guid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">执行时间</div>
          <el-date-picker class="ipt-sty" size="mini" v-model="timeRange" type="daterange" align="center" unlink-panels
            range-separator="-" start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore? '收起筛选': '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">审批状态</div>
          <el-select  size="mini" v-model="page.approvalState" filterable placeholder="请选择执行状态" class="ipt-sty" >
            <el-option v-for="item in approvalStateList" :key="item.value" :label="item.label" :value="item.value"></el-option> </el-select
        ></el-col>
        <el-col :span="6">
          <div class="search-area-div">执行状态</div>
          <el-select size="mini" v-model="page.timeState" filterable placeholder="请选择执行状态" class="ipt-sty">
            <el-option v-for="item in timeStateList" :key="item" :label="item" :value="item"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">任务包状态</div>
          <el-select size="mini" v-model="page.state" filterable placeholder="请选择任务包状态" class="ipt-sty">
            <el-option v-for="item in stateList" :key="item" :label="item" :value="item"></el-option> </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">完成状态</div>
          <el-select size="mini" v-model="page.finishState" filterable placeholder="请选择完成状态" class="ipt-sty">
            <el-option v-for="item in finishStateList" :key="item" :label="item" :value="item"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">锁定状态</div>
          <el-select size="mini" v-model="page.lockStatus" filterable placeholder="请选择锁定状态" class="ipt-sty">
            <el-option v-for="item in lockStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">任务包编号</div>
          <el-input
            size="mini"
            v-model="page.taskNo"
            class="ipt-sty"
            placeholder="请输入任务包编号"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button size="mini" type="info" @click="batchClose"
          >批量设置结算状态</el-button
        >
      </div>

      <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%" v-loading="tableLoading"
        @sort-change="sortChange" @selection-change="handleSelectionChange">
        <!-- selection -->
        <el-table-column type="selection" width="40" header-align="center" align="center" :selectable="selectable" fixed="left"></el-table-column>
        <el-table-column  fixed="left" label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column fixed="left" prop="taskTitle" width="320" label="任务标题" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.taskTitle || '-' }}</template>
        </el-table-column>
        
        <el-table-column prop="createTime" label="审批状态" header-align="center" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.bizApproveVO&&scope.row.bizApproveVO.flowType!='00012'">
              <a class="reject-btn btn" v-if="scope.row.bizApproveVO.approveState == 'R'">已驳回</a>
              <a class="pass-btn btn" v-if="scope.row.bizApproveVO.approveState == 'Y'">已通过</a>
              <a class="ing-btn btn" v-if="scope.row.bizApproveVO.approveState == 'A'">审批中</a>
              <a class="cancel-btn btn" v-if="scope.row.bizApproveVO.approveState == 'C'">已撤销</a>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="tenantName" show-overflow-tooltip min-width="240" label="委托方"
          header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column sortable="custom" prop="serviceTenantName" show-overflow-tooltip min-width="240" label="服务商"
          header-align="center" align="left">
          <template
            slot-scope="scope">{{ scope.row.isChangeService == 'Y' ? scope.row.newServiceTenantName : scope.row.serviceTenantName }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" min-width="180" show-overflow-tooltip label="执行部门" header-align="center"
          align="left">
          <template slot-scope="scope">{{
            getDepartmentName(scope.row.organisationInfo || scope.row.oldOrganisationInfo)
          }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" width="210" label="执行时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.startTime | getDate }} - {{
            scope.row.endTime | getDate
          }}</template>
        </el-table-column>
        <el-table-column prop="taskDetailCount" width="96" show-overflow-tooltip label="任务项目数" header-align="center"
          align="left">
          <template slot-scope="scope">共{{ scope.row.taskDetailCount }}项目</template>
        </el-table-column>
        <el-table-column prop="state" show-overflow-tooltip :render-header="renderHeader" width="100" label="任务包状态"
          header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.state }}</template>
        </el-table-column>

        <el-table-column prop="state" show-overflow-tooltip  width="90" label="锁定状态"
                header-align="center" align="left">
                <template slot-scope="scope">
                  <span style="color:red;" v-if="scope.row.lockStatus == 1">已锁定</span>
                  <span v-else>未锁定</span>
                </template>
        </el-table-column>

        <el-table-column prop="timeState" width="96" label="业务执行状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.timeState }}</template>
        </el-table-column>
        <!-- <el-table-column prop="createUserName" width="96" label="完成状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.finishState }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" width="110" label="成果上传状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.uploadState }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" width="96" label="结算状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.payState }}</template>
        </el-table-column> -->
        <el-table-column prop="taskNo" width="120" label="任务包编号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskNo }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="260px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">

            <a class="txt-color"  v-if="isShowPostBtn(scope.row)"  @click="toDeal(scope.row,0)">去派发</a>

            <template v-if="isShowModifyBtn(scope.row)">
              <a class="txt-color" @click="modifyTask(scope.row)">修改任务包</a>
            </template>
            <a class="txt-color" v-if="
              scope.row.uploadState == '已上传' && scope.row.timeState == '已结束' && scope.row.payState != '已结算'" @click="toPay()">去结算
            </a>
            <a class="txt-color"  @click="toDeal(scope.row,1)">任务详情</a>
            <a class="txt-color"  @click="toSeeProgress(scope.row)">任务进展</a>
            <a class="txt-color"  v-if="selectable(scope.row)"  @click="toSetClose(scope.row)">设置结算状态</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange"   :page-sizes="[10,20,50,100,200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>

    <!-- <div v-if="visible6">
      <el-dialog title="批量调整任务" :visible.sync="visible6" width="45%" center>
        <div class="row-import">
          <div class="left">下载模板</div>
          <div class="right">
            <el-button type="info" @click="downloadTemplate" size="small">下载任务清单</el-button>
            <div class="tipInfo">
              注意事项：<br />
              1、 请先下载任务清单，任务清单中是当前系统自动分解后每个人的任务量明细；<br />
              2、下载后，直接修改里面的任务量数值，再导入，即可批量调整人员任务量
            </div>
          </div>
        </div>
        <div class="row-import">
          <div class="left">导入文件</div>
          <div class="right">
            <el-upload class="avatar-uploader" action="#" :limit="1" :before-upload="beforeAvatarUpload"
              :http-request="uploadImage" multiple>
              <el-button size="small" type="info">点击上传文件</el-button>
            </el-upload>
            <div class="tipInfo">
              注意事项：<br />
              1、点击文件，选择修改好的任务清单文件上传；<br />
              2、仅支持excel文件，大小
              <=10M；<br />
              3、使用 Office 2010 及以上版本，避免出现乱码<br />
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer t-right">
          <el-button plain size="mini" @click="visible6 = false">取消</el-button>
          <el-button size="mini" type="info" @click="modifyUplad">确定</el-button>
        </div>
      </el-dialog>
    </div> -->
    <el-dialog
      title="设置结算状态"
      :visible.sync="dialogVisible"
      top="35vh"
      width="450px">
      <el-radio-group v-model="closeState">
        <el-radio-button v-for="val in closeList" :label="val.value" :disabled="val.label == currentState">{{val.value}}</el-radio-button>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="dialogVisible = false">取 消</el-button>
        <el-button type="info" @click="setClose(closeState)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 247,
      contentMainHeight:window.innerHeight - 200,
      guid: '',
      fileList: [],
      visible6: false,
      dialogVisible:false,
      fullscreenLoading: false,
      textTitle: '配置任务包',
      stateList: ['待派发', '已派发', '部分结算', '已结算', '已失效'],
      timeStateList: ['未开始', '进行中', '已结束'],
      closeList:[
      {
        label: '已派发',
        value: '未结算'
      },
      {
        label: '部分结算',
        value: '部分结算'
      },
      {
        label: '已结算',
        value: '已结算'
      },],
      // closeList:['未结算','部分结算','已结算'],
      closeState:'',
      currentState:'',
      taskTitle:'',
      isBatchClose:false,
      approvalStateList: [
      {
        label: '全部',
        value: '-1'
      },
        
      {
        label: '审批中',
        value: 'A'
      }, {
        label: '已通过',
        value: 'Y'

      }, {
        label: '已驳回',
        value: 'R'

      },
      {
        label: '已撤销',
        value: 'C'

      }],
      finishStateList:['全部','未完成','已完成'],
      lockStatusList:[{label:'已锁定',value:'1'},{label:'未锁定',value:'0'}],
      tenantList: [],
      organisationList: [],
      timeRange: '',
      page: {
        taskBelongCategory:1,
        lockStatus:null,
        serviceTenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationInfo: '',
        startTime: '',
        endTime: '',
        state: '',
        timeState: '',
        approvalState:'-1',
        finishState:'全部',//完成状态
        flowType:["00013",'00015'],
        isService:'Y'
      },
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      sendTenantList: [],
      multipleSelection:[],
      stateGuid:'',
    };
  },
  created() {
    // notifyType	 1控销   2任务包   notifyPartyGuid staffGuid
    this.page.state = this.$route.query.state;
    // this.getTenantList();
    this.getSendTenantList();
    this.getList();
  },
  activated() {
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 340;
        this.contentMainHeight = window.innerHeight - 250;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 247;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    //排序
    sortChange(column) {
      console.log(column)
      if (column.prop == "tenantName" && column.order) {
        this.page.orderColumn = 'tenant_name'
      } else if (column.prop == "serviceTenantName" && column.order) {
        this.page.orderColumn = 'service_tenant_name'
      } else {
        this.page.orderColumn = '';
      }
      this.getList()// 查询列表方法
    },
    // 多选
    handleSelectionChange(val){
      this.multipleSelection = [];
      
      val.forEach((item)=>{
        this.multipleSelection.push(item.guid)
      })
      console.log('vv',this.multipleSelection);
    },
    //表格禁选
    selectable(row, index) {
      let userInfo=JSON.parse(localStorage.userInfo)
      if(row.createUserId!==userInfo.userGuid){
        return false
      }
      if(row.state=='已派发'||row.state=='未结算'||row.state=='部分结算'||row.state=='已结算'){
        return true          //可选
      }
      return false    //禁用
    },
    //批量设置结算状态 
    batchClose() {
        console.log('..',this.multipleSelection);
        
        if (!this.multipleSelection.length) {
          this.$message.error("请勾选数据！");
          return;
        }
        this.currentState='';
        this.stateGuid = '';
        this.taskTitle = '';
        this.closeState=''
        this.isBatchClose = true;
        this.dialogVisible = true;
      },
    toSetClose(detail) {
      this.currentState=detail.state;
      this.stateGuid = detail.guid;
      this.taskTitle = detail.taskTitle;
      this.closeState=''
      this.isBatchClose = false;
      this.dialogVisible = true;
    },
    setClose(state) {
      var self = this;
      let text=state
      console.log('state',state);
      
      if(state=='已结算'){
        text='全部已结算'
      }
      let str=''
      if(this.isBatchClose){
        str=`确定将已选的${self.multipleSelection.length}个任务包设为${text}吗？`
      }else{
        str=`确定将【${self.taskTitle}】设为${text}吗？`
      }
      
      self
        .$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.fullscreenLoading = true;
          var req = {
            guids: self.stateGuid?[self.stateGuid]:self.multipleSelection,
            state: state,
          };
          self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit-task-state`, req).then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('设置成功！');
              self.dialogVisible = false;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    // toChangeNum(detail) {
    //   this.guid = detail.guid;
    //   this.visible6 = true;
    // },
    //导入-上传文件
    uploadImage(file) {
      this.fileList = file;
    },
    // modifyUplad() {
    //   let formData = new FormData();
    //   let file = this.fileList;
    //   if (file.length == 0) {
    //     this.$message.error('请上传文件清单！');
    //     return;
    //   }
    //   formData.append('file', file.file, file.filename);
    //   this.fullscreenLoading = true;
    //   this.api.postFile(`/${serverConfig.msSalesPerformService}/task/data/import-detail`, formData).then((res) => {
    //     this.fullscreenLoading = false;
    //     this.visible6 = false;
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       this.$message.success('调整成功！');

    //     } else {
    //       this.$message.error(res.data.msg);
    //     }
    //   });
    // },
    //导入-上传前校验
    beforeAvatarUpload(file) {
      let testmsg = file.name ? file.name.split('.')[1] : '';
      const isJPG = testmsg === 'xls' || testmsg === 'xlsx' || testmsg === 'xlsm';
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error('文件格式不正确!');
      }
      if (!isLt2M) {
        this.$message.error('文件大小不能超过10MB!');
      }
      return isJPG && isLt2M;
    },
    downloadTemplate() {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/task/data/export-detail?guid=${this.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    getDepartmentName(list) {
      if (typeof list == 'string') {
        list = JSON.parse(list);
      }
      let personArr = [];
      let personTip = '';
      let departmentArr = [];
      let departmentTip = '';
      let personNum = 0;
      let departmentNum = 0;
      if (list && list.length > 0) {
        list.forEach(i => {
          if (i.objectType == '人员') {
            personArr.push(i.organisationName || i.name);
            personNum = personNum + 1;
          } else {
            departmentNum = departmentNum + 1;
            departmentArr.push(i.organisationName || i.name);
          }
        });
      }
      personTip =
        personArr.length > 2
          ? personArr.splice(0, 2).join('、') + `等${personNum}个人`
          : personArr.splice(0, 2).join('、');
      // console.log(personArr);
      departmentTip =
        departmentArr.length > 2
          ? departmentArr.splice(0, 2).join('、') + `等${departmentNum}个部门`
          : departmentArr.splice(0, 2).join('、');
      return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.page.pageIndex = 1;
      if (self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.endTime = self.timeRange[1] + ' ' + '23:59:59';
      }
      var req = JSON.parse(JSON.stringify(this.page));
      req.approvalState = req.approvalState&& req.approvalState!='-1'?[req.approvalState]:null;
      req.state = req.state ? [req.state] : ['待派发', '已派发', '部分结算', '已结算', '已失效'];
      req.finishState = req.finishState=='全部'?'':req.finishState;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      var req = JSON.parse(JSON.stringify(this.page));
      req.state = req.state ? [req.state] : ['待派发', '已派发', '部分结算', '已结算', '已失效'];
      req.approvalState = req.approvalState&& req.approvalState!='-1'?[req.approvalState]:null;
      req.finishState = req.finishState=='全部'?'':req.finishState;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['010201', '0101'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleChangeCompany(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        }
      });
    },
    addVersion() {
      this.$router.push('/taskDeliverAdd?productGuid='+this.$route.query.productGuid);
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationInfo: '',
        startTime: '',
        endTime: '',
        state: '',
        timeState: '',
        serviceTenantGuid: localStorage.guid,
        approvalState:'-1',
        finishState:'全部',
        flowType:["00013",'00015'],
        isService:'Y',
        taskBelongCategory:1,
        lockStatus:null
      };
      this.organisationList = [];
      this.timeRange = '';
      this.getList();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    reBackVersion(detail, type) {
      if (type == 0) {
        //撤回
        this.fullscreenLoading = true;
        var self = this;
        var req = {
          guid: detail.guid,
          state: '已撤回',
          currentTenantGuid:localStorage.guid
        };
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('撤回成功');
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        //重新提交
        this.$router.push('/taskDeliverAdd?guid=' + detail.guid + '&is_edit=1&productGuid='+this.$route.query.productGuid);
      }
    },
    
    modifyTask(detail) {
      this.$router.push('/taskDeliverModify-02?guid=' + detail.guid + '&state=' + detail.state+'&productGuid='+this.$route.query.productGuid); //去修改
    },
    see(detail) {
      this.$router.push('/taskDeliverAdd?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid); //查看
    },
    toDeal(detail,type) {
      let url = type?'/taskDeliverDetail?guid=' + detail.guid:'/taskDeliverModify?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid;
      this.$router.push(url); //去处理
    },
    toUpload() {
      this.$router.push('/operationReport?productGuid='+this.$route.query.productGuid); //查看
    },
    toPay() {
      this.$router.push('/freeList?productGuid='+this.$route.query.productGuid);
    },
    toSeeProgress(detail) {
      this.$router.push('/taskProgress?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid); //去处理
    },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '1、待派发：需要代运营人员进行任务的下发；',
                h('br'),
                '2、已派发：指任务已下发给业务员；',
                h('br'),
                '3、部分结算：任务包中部分人的任务已进行结算(企业端不展示)；',
                h('br'),
                '4、已结算：任务包中所有人的任务已进行结算；',
                h('br'),
                '5、已失效：任务包已取消派发，任务包终止；',
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    isShowPostBtn(obj){
      let userInfo = JSON.parse(localStorage.userInfo)
      if (obj.createUserId !== userInfo.userGuid) {
        return false
      }
      //历史的包
      if (obj.state == '待派发' && !obj.bizApproveVO) {
        return true
      }
      if (obj.state == '待派发' && obj.bizApproveVO.approveState != 'A') {
        return true
      }
      //待派发的包 发起审核（II）非正在审核的包
      if (obj.state == '待派发' && obj.bizApproveVO.flowType == '00015' && obj.bizApproveVO.approveState != 'A') {
        return true
      }
      //协配的包审核通过 未发起审核（II）
      if (obj.state == '待派发' && obj.bizApproveVO.flowType == '00012' && obj.bizApproveVO.approveState == 'Y') {
        return true
      }
      return false;
    },
    isShowModifyBtn(obj){
      let userInfo = JSON.parse(localStorage.userInfo)
      if (obj.createUserId !== userInfo.userGuid) {
        return false
      }
      // var dateA = new Date(obj.startTime);
      // var dateB = new Date(obj.endTime);
      // var dateC = new Date();
      // if (dateC - dateA < 0 || dateC - dateB > 0) {//不在执行时间内
      //   return false
      // }
      //历史的包
      if (obj.state == '待派发'&&!obj.bizApproveVO) {
        return true
      }
      //待派发的包 发起审核（II）审核通过
      if (obj.state == '待派发' && obj.bizApproveVO.flowType == '00015' && obj.bizApproveVO.approveState != 'A') {
        return true
      }

      //协配的包审核通过 未发起审核（II）
      if (obj.state == '待派发' && obj.bizApproveVO.flowType == '00012' && obj.bizApproveVO.approveState == 'Y') {
        return true
      }

      if (obj.state == '已派发'||obj.state == '部分结算') {
        return true
      }

      return false;
    }
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.search-area-div{
  width:72px;
}
.el-col-6{
  display: flex;
}
 .el-col-8{
  display: flex;
}
</style>